/* esm.sh - applesauce-core@5.2.0/dist/helpers/contacts */
export * from "/*applesauce-core@5.2.0/esnext/dist/helpers/contacts.mjs";
